import './index.css'

export const Breaker = (props) => {
    return (
        <div id={props.id}>
        </div>
    )
}